// Long admin values (UUIDs, webhook event ids, emails) with line-break opportunities at their separators, so a narrow
// column wraps them at a hyphen, a colon or before the "@" instead of mid-token, and a table keeps its container step
// at 1280px (ui/DESIGN.md §5). <wbr> adds no character, so a copied value stays intact; `wrap-anywhere` on the
// container stays the fallback for a single segment longer than the line.

import { Fragment } from "react";

export type BreakAt = "id" | "email";

/** Pieces of `text`, each ending where a line may break: after "-" or ":" (id), or before "@" (email). */
function segments(text: string, at: BreakAt): string[] {
  const out: string[] = [];
  let current = "";
  for (const ch of text) {
    if (at === "email" && ch === "@" && current) {
      out.push(current);
      current = "";
    }
    current += ch;
    if (at === "id" && (ch === "-" || ch === ":")) {
      out.push(current);
      current = "";
    }
  }
  if (current) out.push(current);
  return out;
}

export function BreakableText({ text, at }: { text: string; at: BreakAt }) {
  return (
    <>
      {segments(text, at).map((part, i) => (
        <Fragment key={i}>
          {i > 0 && <wbr />}
          {part}
        </Fragment>
      ))}
    </>
  );
}
